import React from 'react';
import {
  ArrowSquareOut, Gear, Image, Package, PaintBrushBroad, Printer, SignOut, SquaresFour, Moon, Sun,
} from '@phosphor-icons/react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import { supportedLanguages, useI18n } from '../../i18n';

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const { isDarkMode, toggleTheme } = useTheme();
  const { language, changeLanguage, t } = useI18n();

  const links = [
    { to: '/admin', label: t('admin.dashboard'), icon: SquaresFour, end: true },
    { to: '/admin/artworks', label: t('admin.artworks'), icon: PaintBrushBroad },
    { to: '/admin/images', label: t('admin.images'), icon: Image },
    { to: '/admin/orders', label: t('admin.orders'), icon: Package },
    { to: '/admin/printify', label: t('admin.printify'), icon: Printer },
    { to: '/admin/settings', label: t('admin.settings'), icon: Gear },
  ];

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/adminlogin');
  };

  return (
    <div className="min-h-screen bg-background text-text-primary">
      <header className="border-b border-border bg-surface">
        <div className="page-shell flex min-h-[78px] flex-wrap items-center justify-between gap-4 py-3">
          <Link to="/admin" className="flex items-center gap-3">
            <img src="/favicon.ico" alt="" className="h-9 w-9 object-contain" aria-hidden="true" />
            <span><span className="editorial-eyebrow block text-[9px]">{t('admin.label')}</span><strong className="font-display text-2xl font-semibold">{t('admin.title')}</strong></span>
          </Link>
          <div className="flex items-center gap-2">
            <span className="hidden items-center gap-2 pr-3 text-xs text-text-secondary sm:flex"><span className="h-2 w-2 rounded-full bg-green-500" />{t('admin.online')}</span>
            <select value={language} onChange={(event) => changeLanguage(event.target.value)} className="h-10 border border-border bg-background px-2 text-xs font-semibold">
              {supportedLanguages.map((item) => <option key={item.code} value={item.code}>{item.short}</option>)}
            </select>
            <button type="button" onClick={toggleTheme} className="grid h-10 w-10 place-items-center rounded-full border border-border" aria-label={isDarkMode ? t('common.lightMode') : t('common.darkMode')}>{isDarkMode ? <Sun size={18} /> : <Moon size={18} />}</button>
            <Link to="/" className="grid h-10 w-10 place-items-center rounded-full border border-border" aria-label={t('admin.viewSite')}><ArrowSquareOut size={18} /></Link>
          </div>
        </div>
      </header>

      <div className="page-shell grid gap-6 py-7 lg:grid-cols-[245px_minmax(0,1fr)] lg:gap-9 lg:py-10">
        <aside className="lg:sticky lg:top-6 lg:self-start">
          <nav className="flex gap-2 overflow-x-auto border-b border-border pb-3 lg:grid lg:gap-1 lg:overflow-visible lg:border-b-0 lg:pb-0" aria-label="Administration">
            {links.map(({ to, label, icon: Icon, end }) => (
              <NavLink key={to} to={to} end={end} className={({ isActive }) => `flex min-h-11 shrink-0 items-center gap-3 border-l-2 px-4 py-3 text-sm font-medium transition-colors ${isActive ? 'border-primary bg-surface text-text-primary' : 'border-transparent text-text-secondary hover:bg-surface hover:text-text-primary'}`}>
                <Icon size={19} /><span>{label}</span>
              </NavLink>
            ))}
          </nav>
          <button type="button" onClick={handleLogout} className="mt-6 hidden w-full items-center gap-3 border-t border-border px-4 py-4 text-sm text-text-secondary hover:text-primary lg:flex"><SignOut size={19} />{t('admin.logout')}</button>
        </aside>

        <main className="min-w-0 border border-border bg-surface p-5 shadow-[0_18px_45px_var(--shadow)] sm:p-8">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
